<template>
  <div class="contenedor-principal">
    <h1>Formación Profesional y Técnica</h1>

    <p>En Geobizi acompañamos a empresas y equipos profesionales en su transformación hacia modelos más sostenibles, digitales y humanos. No solo compartimos información, sino que diseñamos procesos de aprendizaje a medida.</p>

    <section class="bloques-gestion">
      <div class="bloque-modalidad">
        <h3>Formación a medida para tu equipo</h3>
        <p>Ponemos nuestra experiencia en Lanbide y otros entornos formativos al servicio de tu equipo. Impartimos formación en áreas como ecoturismo, huertos urbanos y gestión del ocio, además de habilidades clave como la comunicación efectiva, el trabajo en equipo y el uso práctico de la IA.</p>
        <router-link to="/contacto?servicio=formacion_tecnica" class="btn-servicio mleft">Preguntar sobre formación técnica</router-link>
      </div>
    </section>

    <h2>Áreas de especialidad</h2>
    <p>Nuestra formación se adapta siempre a vuestras necesidades, basándonos en nuestra experiencia en estos ámbitos:</p>

    <ul class="lista-formacion">
      <li><strong>Innovación:</strong> Uso ético de la IA y herramientas digitales.</li>
      <li><strong>Gestión y Equipos:</strong> Comunicación efectiva, roles de equipo y liderazgo.</li>
      <li><strong>Medioambiente:</strong> Ecoturismo, diseño de espacios verdes y regeneración.</li>
    </ul>

    <section class="faq-section">
      <h2>Preguntas frecuentes</h2>
      <h3>¿Cómo adaptáis la formación a cada equipo?</h3>
      <p>Nos reunimos con vosotros para conocer a fondo vuestro proyecto. No damos charlas genéricas; trabajamos sobre vuestra realidad para que los cambios sean aplicables desde el primer día.</p>
      <h3>¿La formación es presencial u online?</h3>
      <p>Nos adaptamos. Realizamos sesiones presenciales en empresas y entidades, o sesiones online si la dinámica del proyecto así lo requiere.</p>
    </section>

    <div class="imagen-trio">
      <div><img class="img" src="/imagenes/servicios/formacion/formacion1.avif" alt="Sesión de formación" loading="lazy" /></div>
      <div><img class="img" src="/imagenes/servicios/formacion/formacion2.avif" alt="Trabajo en grupo" loading="lazy" /></div>
      <div><img class="img" src="/imagenes/servicios/formacion/formacion3.avif" alt="Sesión de trabajo" loading="lazy" /></div>
    </div>
  </div>
</template>

<script setup>
import { useHead } from '@vueuse/head'
const pageUrl = 'https://www.geobizi.com/servicios/formacion'
useHead({
  title: 'Formación Profesional y Técnica | Geobizi',
  meta: [{ name: 'description', content: 'Formación a medida en ecoturismo, huertos urbanos y gestión del ocio, comunicación, trabajo en equipo y uso práctico de la IA para empresas y equipos profesionales.' }],
  link: [{ rel: 'canonical', href: pageUrl }]
})
</script>

<style scoped>
.lista-formacion { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
.faq-section { margin-top: 3rem; padding: 2rem; background: var(--megashoftgreen); border-radius: 0.5rem; }
.contenido-seccion ul {
  flex: 1;
  min-width: 220px;
  margin: 0;
  padding-left: 1.2rem;
}

.contenido-seccion > img {
  align-self: center;
}

.icono {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-bottom: 8px;
  vertical-align: middle;
}
</style>
